import Protected from "@/pages/protected";
import { IperiaOperationsPage } from "@/pages/registration/iperia-operations";
import type { RouteObject } from "react-router-dom";

const IperiaOperationsRoute: RouteObject = {
    path: "iperia",
    element: (
        <Protected profiles={["iperia_operator", "sales_admin", "system_admin"]}>
            <IperiaOperationsPage />
        </Protected>
    )
};

export default IperiaOperationsRoute;
